import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
//import { Link } from 'react-router-dom';

import { SignUpLink } from './SignUp';
import { PasswordForgetLink } from './PasswordForget';
//import { PasswordChangeLink } from './PasswordChange';
import { auth } from '../firebase';
import * as routes from '../constants/routes';
import firebase from 'firebase';
//import AuthUserContext from './AuthUserContext';
//import withAuthentication from './withAuthentication';
//import withAuthorization from './withAuthorization';

var pageStyle = {
  //backgroundImage: 'url(' + imgUrl + ')',
  textAlign: "justify",
  padding: "60px",
  margin: "20px",
  WebkitTransition: 'all', // note the capital 'W' here
  msTransition: 'all' // 'ms' is the only lowercase vendor prefix
};


const SignInPage = ({ history }) =>
  <div style={pageStyle}>
    <h2>Sign In Here</h2>
    <SignInForm history={history} />
    <PasswordForgetLink />

    <SignUpLink />
  </div>

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

class SignInForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }




  onSubmit = (event) => {
    event.preventDefault();
    const {
      email,
      password,
    } = this.state;

    const {
      history,
    } = this.props;

    /*  What is in FB on signup

      const cust = {
        username: username,
        company: company,
        telephoneNumber: telephoneNumber,
        id: user.email,
        signupdate: sud,
        questionnaire: "[0,0,0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0]",
        shouldemail: "no",
        date: new Date().toJSON(),
        eligible: eligible
        }

        */

    auth.doSignInWithEmailAndPassword(email, password)

      .then (()=>{firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          // User is signed in.
          console.log("email of user  signed in  " + user.email);
          console.log("firebase uid of user is signed in  " + user.uid);
//***************************************************** */
/*
var ref2=firebase.database().ref('/users/'+ user.uid); 
ref2.once('value').then(function(snapshot) {
        // All promises succeeded.
        const username=localStorage.getItem('username');
        console.log("Firebase username from local storage : " + username)
        //console.log("USERNAME RETURNED FROM LOCAL STORAGE" + username)
var data= snapshot.val()
var usernameFromFB=data.username
console.log("Firebase username : " + usernameFromFB)
  var company=data.company;
  var username=data.username;
  var eligible=data.eligible;
  var telephoneNumber=data.telephoneNumber;
  var signupdate=data.signupdate;
  var questionnaire=data.questionnaire;  
  var shouldemail=data.shouldemail;
  var id=data.id;  
  localStorage.clear();
                                  console.log("+++++++++++++++++Storing ++++++++++++++++++");
                                  localStorage.setItem("company",company);
                                  localStorage.setItem("username",username);
                                  localStorage.setItem("eligible",eligible);
                                  localStorage.setItem("telephoneNumber",telephoneNumber);
                                  localStorage.setItem("signupdate",signupdate);
                                  localStorage.setItem("questionnaire",questionnaire);
                                  localStorage.setItem("id",id);
                                  localStorage.setItem("shouldemail",shouldemail);
                                  localStorage.setItem("date", new Date().toJSON());
                                  localStorage.setItem("justsignedup", 'no');                                
      
              } else
              console.log(e + " is email stored  SignIn user.email " + user.email);


             });
            });
          

        } else {
          // No user is signed in
          console.log('No user ! ' + user.email);
        }
      });                      
   
      })   //end of then
*/
//************************************************************/
            var ref = firebase.database().ref('/users');  // this is long winded use user id!!! no need to loop
            ref.on("value", function(snapshot) {
                          snapshot.forEach(function(childSnapshot) {
                                var childData = childSnapshot.val();

                                var e =childData.id;  // id is the email
                                console.log("email stored SignIn  "+ e);
                                if (e===user.email){
                                  var company=childData.company;
                                  var username=childData.username;
                                  var eligible=childData.eligible;
                                  var telephoneNumber=childData.telephoneNumber;
                                  var signupdate=childData.signupdate;
                                  var questionnaire=childData.questionnaire;  
                                  var shouldemail=childData.shouldemail;
                                  var id=childData.id;
// NB After signUP we execute SignIn automatically
/*
                                  localStorage.clear();
                                  console.log("+++++++++++++++++Storing ++++++++++++++++++");
                                  localStorage.setItem("company",company);
                                  localStorage.setItem("username",username);
                                  localStorage.setItem("eligible",eligible);
                                  localStorage.setItem("telephoneNumber",telephoneNumber);
                                  localStorage.setItem("signupdate",signupdate);
                                  localStorage.setItem("questionnaire",questionnaire);
                                  console.log("QUESTIONNAIRE " +questionnaire)
                                  localStorage.setItem("id",id);
                                  localStorage.setItem("shouldemail",shouldemail);
                                  localStorage.setItem("date", new Date().toJSON());
                                  localStorage.setItem("justsignedup", 'no');

*/

              } else
              console.log(e + " is email stored  SignIn user.email " + user.email);


             });
            });
          

        } else {
          // No user is signed in
          console.log('No user ! ' + user.email);
        }
      });
})


.then(() => {
  this.setState(() => ({ ...INITIAL_STATE }));
  history.push(routes.HOME);
})
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();

  }

/*
doSomething()
.then(result => doSomethingElse(result))
.then(newResult => doThirdThing(newResult))
.then(finalResult => {
  console.log(`Got the final result: ${finalResult}`);
})
.catch(failureCallback);
Important: Always return results, otherwise callbacks won't catch the result of a previous promise (with arrow functions () => x is short for () => { return x; }).
*/



  render() {
    const {
      email,
      password,
      error,
    } = this.state;

    const isInvalid =
      password === '' ||
      email === '';

    return (
      <form onSubmit={this.onSubmit}>
        <input
          value={email}
          onChange={event => this.setState(byPropKey('email', event.target.value))}
          type="text"
          placeholder="Email Address"
        />
        <input
          value={password}
          onChange={event => this.setState(byPropKey('password', event.target.value))}
          type="password"
          placeholder="Password"
        />
        <button disabled={isInvalid} type="submit">
          Sign In
        </button>

        { error && <p>{error.message}</p> }
      </form>
    );
  }
}

export default withRouter(SignInPage);

export {
  SignInForm,
};



// WEBPACK FOOTER //
// ./src/components/SignIn.js